// Hilfen rund um Spieler: Farben, Rang, Ergebnis-Text.
//
// Host und Mitspieler muessen dieselbe Farbe fuer dieselbe Person sehen,
// ohne dass sie irgendwo gespeichert wird. Deshalb nach Namen sortiert:
// beide Seiten kennen dieselben Namen, also dieselbe Reihenfolge.

export const SPIELER_FARBEN = 8;

const schluessel = (name) => (name || "").trim().toLocaleLowerCase("de");

/** Name -> Farbnummer 1..8, stabil ueber alle Geraete. */
export function farbNummern(namen) {
  const sortiert = [...new Set(namen.map(schluessel))].sort((a, b) => a.localeCompare(b, "de"));
  const nummer = {};
  sortiert.forEach((n, i) => {
    nummer[n] = (i % SPIELER_FARBEN) + 1;
  });
  return (name) => nummer[schluessel(name)] || 1;
}

/** Erster Buchstabe fuer den Avatar. */
export function initiale(name) {
  const n = (name || "").trim();
  return n ? n[0].toLocaleUpperCase("de") : "?";
}

/**
 * Punktestand sortiert, mit Platz (Gleichstand = gleicher Platz).
 * eintraege: [{ name, score, ... }]
 */
export function rangliste(eintraege) {
  const sortiert = [...eintraege].sort((a, b) => b.score - a.score);
  let platz = 0;
  let vorher = null;
  return sortiert.map((e, i) => {
    if (e.score !== vorher) {
      platz = i + 1;
      vorher = e.score;
    }
    return { ...e, platz };
  });
}

/** Wer fuehrt? Null, solange niemand einen Punkt hat. */
export function fuehrende(eintraege) {
  const spitze = Math.max(0, ...eintraege.map((e) => e.score));
  if (spitze === 0) return [];
  return eintraege.filter((e) => e.score === spitze);
}

const punkteText = (n) => (n === 1 ? "1 Punkt" : `${n} Punkte`);
// Nach "mit": Dativ ("mit 2 Punkten")
const mitPunkten = (n) => (n === 1 ? "1 Punkt" : `${n} Punkten`);

/**
 * Ueberschrift + Unterzeile fuer den Endstand.
 * ich: Name des eigenen Spielers (Mitspieler-Ansicht) oder null (Host).
 */
export function ergebnisText(eintraege, ich = null) {
  const liste = rangliste(eintraege);
  if (liste.length === 0) return { titel: "Spiel beendet", zeile: "" };
  const erste = liste.filter((e) => e.platz === 1);
  const spitze = erste[0].score;

  if (spitze === 0) return { titel: "Keine Punkte", zeile: "Niemand hat gepunktet" };

  const meiner = ich ? liste.find((e) => schluessel(e.name) === schluessel(ich)) : null;

  if (erste.length > 1) {
    const namen = erste.map((e) => e.name);
    const titel = "Gleichstand!";
    const zeile = `${namen.slice(0, -1).join(", ")} und ${namen[namen.length - 1]} mit je ${mitPunkten(spitze)}`;
    if (meiner && meiner.platz === 1) return { titel: "Geteilter Sieg!", zeile };
    return { titel, zeile };
  }

  const sieger = erste[0];
  const zweite = liste.find((e) => e.platz > 1);
  let abstand = "";
  if (zweite) {
    const d = spitze - zweite.score;
    abstand = d === 1 ? ` · knapp vor ${zweite.name}` : ` · ${d} vor ${zweite.name}`;
  }

  if (meiner) {
    if (meiner === sieger) return { titel: "Du hast gewonnen!", zeile: `${punkteText(spitze)}${abstand}` };
    return { titel: `${sieger.name} gewinnt`, zeile: `Du: Platz ${meiner.platz} mit ${mitPunkten(meiner.score)}` };
  }
  return { titel: `${sieger.name} gewinnt`, zeile: `${punkteText(spitze)}${abstand}` };
}
